module.exports = __webpack_public_path__ + "static/media/april-2022.c79a06ed.svg";